import moment from 'moment'
import routes from './routes'
import { Fetch } from '../fetch'

class DashboardService {
  async getQuickNumbers () {
    return Fetch('get', routes.QUICK_NUMBERS)
  }

  async getEvents () {
    const year = moment(new Date()).format('YYYY')
    return Fetch('get', routes.EVENTS(year))
  }
}

export default new DashboardService()
